import { useDropzone } from "react-dropzone";
import { Box, Card, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useCallback } from "react";
import LastActivities from "./LastActivities";
import { Icon } from "@iconify/react";

export default function MyDropzone(props: {
  openUploadDialog: boolean;
  updateOpenUploadDialog: any;
  file?: File;
  updateFile: any;
}) {
  const { t } = useTranslation();
  //const [openWrong, setOpenWrong] = React.useState(false);

  const onDropAccepted = useCallback(
    (acceptedFiles) => {
      props.updateOpenUploadDialog(true);
      props.updateFile(acceptedFiles[0]);
    },
    [props]
  );

  /* const onDropRejected = useCallback(rejectedFiles => {
   props.setOpenWrongFormatDialog(true);
   setOpenWrong(true);
  }, []); */

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: { "application/octet-stream": [".apk", ".ipa"] },
    onDropAccepted,
  });

  return (
    <Card
      sx={{
        boxShadow: 5,
        borderRadius: 1.5,
        alignItems: "center",
        justifyContent: "center",
      }}
      style={{ height: "100%" }}
    >
      <div
        {...getRootProps({
          onClick: (event) => event.stopPropagation(),
        })}
      >
        <input {...getInputProps()} />
        <div className="text-center">
          {isDragActive ? (
            <Box
              sx={{
                height: 420,
                p: 2,
                border: "2px dashed #1363DF",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Stack alignItems="center">
                <Typography textAlign="center" variant="h5">
                  {t("Drop your .apk or .ipa file here...")}
                </Typography>
                <Icon
                  icon="material-symbols:smartphone"
                  width="50"
                  color="grey"
                />
              </Stack>
            </Box>
          ) : (
            <LastActivities />
          )}
        </div>
      </div>
    </Card>
  );
}
